module.exports = __webpack_public_path__ + "img/img2.4b8b6ce1.png";